<template>
  <w-icon-wrapper
    :height='22'
    :width='24'
    icon-name='work-logout-icon'
    view-box='0 0 24 22'
  >
    <g
      id='_9_Logout_Icon'
      data-name='9 Logout_Icon'
      transform='translate(0 -1)'
    >
      <path
        id='Pfad_55655'
        d='M15,15a1,1,0,0,0-1,1v5H2V3H14V8a1,1,0,0,0,2,0V1H0V23H16V16A1,1,0,0,0,15,15Z'
        data-name='Pfad 55655'
        fill='currentColor'
      />
      <path
        id='Pfad_55656'
        d='M23.308,11.34a.809.809,0,0,0-.077-.078L20.288,8.3A1,1,0,0,0,18.868,9.7L20.154,11H9.578a1,1,0,0,0,0,2h10.56l-1.32,1.283a1,1,0,0,0,1.395,1.434L24,12.037Z'
        data-name='Pfad 55656'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconLogout' };
</script>
